import Vue from 'vue'
import VueRouter from 'vue-router'
import Competitions from '@/views/Competitions'
import Competition from '@/views/Competition'
import NatOrgs from '@/views/NatOrgs'
import NatOrgDetail from '@/views/NatOrgDetail'
import InviteUsers from '@/views/InviteUsers'
import AddUsersToCompetitions from '@/views/AddUsersToCompetitions'

Vue.use(VueRouter)

export default new VueRouter({
    routes: [
        {
            path: '/competition/:id',
            name: 'Competition',
            component: Competition
        },
        {
            path: '/natorg/:id',
            name: 'National Organization Details',
            component: NatOrgDetail
        },        
        {
            path: '/natorgs',
            name: 'National Organizations',
            component: NatOrgs
        },
        {
            path: '/invite/:noid',
            name: 'Invite New Org Users',
            component: InviteUsers
        },
        {
            path: '/invite',
            name: 'Invite New Users',
            component: InviteUsers
        },
        {
            path: '/addtocomp/:noid',
            name: 'Add Org Users To Competitions',
            component: AddUsersToCompetitions
        },
        {
            path: '/addtocomp',
            name: 'Add Users To Competitions',
            component: AddUsersToCompetitions
        },
        {
            path: '/:noid',
            name: 'Competitions',
            component: Competitions
        },
        {
            path: '/',
            name: 'Competitions',
            component: Competitions
        }
    ]
})